export function initializeTableNavbar() {
  $('.block-table__sticky-navbar li a[href^="#"]').click(function (event) {
    // Prevent from default action to intitiate
    event.preventDefault();

    //remove active from all anchor and add it to the clicked anchor
    $('.block-table__sticky-navbar li a[href^="#"]').removeClass("active");
    $(this).addClass("active");

    var target = $(this).attr("href");
    var offset = $(target).offset().top - ($("header").height() + 48);

    $("html, body").animate(
      {
        scrollTop: offset,
      },
      500
    );

    window.location.hash = target;
  });

  //check the pages when scroll event occurs
  $(window).scroll(function () {
    // Get the current vertical position of the scroll bar
    let position = Math.round(
      $(this).scrollTop() + ($("header").height() + 48 + 1)
    );
    $('.block-table__sticky-navbar li a[href^="#"]').each(function () {
      let anchorId = $(this).attr("href");
      let target = Math.round($(anchorId).offset().top);
      // check if the document has crossed the page
      if (position >= target) {
        //remove active from all anchor and add it to the clicked anchor
        $('.block-table__sticky-navbar li a[href^="#"]').removeClass("active");
        $(this).addClass("active");
      }
    });
  });
}
